import React, { useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Tag, Spin, Typography, Row, Col, Input, message } from 'antd';
import { NavBar, Popup, List, Dialog } from 'antd-mobile';
import { RootState } from '@/store';
import Loading from '@/components/Loading';
import RtcClient from '@/lib/RtcClient';
import {
  clearCurrentMsg, setInterruptMsg, updateAIGCState,
} from '@/store/slices/room';
import Config from '@/config';
import styles from './index.module.less';
import WaveGIF from '@/assets/img/Wave.gif';
import DoubaoProfileSVG from '@/assets/img/user_cyber.png';
import StopRobotBtn from '@/assets/img/StopRobotBtn.svg';
import { AddOutline, CalendarOutline, CloseOutline, DeleteOutline, SendOutline } from 'antd-mobile-icons';
import { useNavigate } from 'react-router-dom';
import { post } from '@/utils/request';
import openAPIs from '@/app/api';
import aigcConfig from '@/config';

import {
  setHistoryMsg,
} from '@/store/slices/room';

const { Search } = Input;

const lines: (string | React.ReactNode)[] = [
  <div key="problem1">
    <Tag className={styles.tagProblem}>人生的意义是什么?</Tag>
  </div>,
  <div key="problem2">
    <Tag className={styles.tagProblem}>如何平衡个人理想和家庭期望?</Tag>
  </div>,
  <div key="problem3">
    <Tag className={styles.tagProblem}>在当下内卷的社会里，我能够选择躺平吗?</Tag>
  </div>,
];

function Conversation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //历史消息
  const msgHistory = useSelector((state: RootState) => state.room.msgHistory);

  //用户信息
  const { userId } = useSelector((state: RootState) => state.room.localUser);

  //房间信息
  const { isAITalking, isUserTalking, roomId, isAIGCEnable } = useSelector((state: RootState) => state.room);
  const isAIReady = msgHistory.length > 0;
  const containerRef = useRef<HTMLDivElement>(null);

  //弹窗
  const [popupVisible, setPopupVisible] = useState(false);

  //当前状态
  const [status, setStatus] = useState('voice');

  useEffect(() => {
    //处理页面的scrollTop
    const container = containerRef.current;
    if (container) {
      container.scrollTop = container.scrollHeight - container.clientHeight;
    }
  }, [msgHistory.length]);

  /**
   * 处理打断
   */
  const handleInterrupt = () => {
    RtcClient.commandAudioBot(roomId!, userId!, 'interrupt');
    dispatch(setInterruptMsg());
  };

  /**
   * 处理aigc模式
   * @param roomId
   * @param userId
   */
  const handleAIGCModeStart = async (roomId: any, userId: any) => {
    if (isAIGCEnable) {
      await RtcClient.stopAudioBot(roomId, userId);
      dispatch(clearCurrentMsg());
      await RtcClient.startAudioBot(roomId, userId);
    } else {
      await RtcClient.startAudioBot(roomId, userId);
    }
    dispatch(updateAIGCState({ isAIGCEnable: true }));
  };

  /**
   * 结束当前会话
   */
  const stopConversation = () => {
    //结束当前会话
    let conversationId = localStorage.getItem('conversationId');
    post('/cbc/conversation/ops/stop', {
      conversationId: conversationId,
    }).then((res) => {
      console.log(res);
    });
  };

  /**
   * 开启新会话
   */
  const startNewConversation = async () => {
    //结束当前会话
    stopConversation();

    //开启会话
    //处理aigc模式
    await handleAIGCModeStart(roomId, userId);
  };



  /**
   * 文本输入框
   */
  const [content, setContent] = useState<any>('');
  const onChange = async (e: any) => {
    setContent(e.target.value);
  };
  const onSearch = async (value: any) => {
    console.log(value);
    //发送文字
    const res = await openAPIs.UpdateVoiceChat({
      AppId: aigcConfig.AppId,
      RoomId: roomId,
      TaskId: userId,
      Command: 'ExternalTextToLLM',
      Message: value,
      InterruptMode: 1,
    });
    //记录消息
    //{
    //     "text": "你好，欢迎来到我的咨询室。我是儒家哲学咨询智能体 — 赛博子曰，我精通孔子哲学思想，擅长帮助人们解决思想和观念上的困惑。我的",
    //     "user": "RTCBotTest",
    //     "paragraph": false,
    //     "definite": false
    // }
    dispatch(setHistoryMsg({
      text: value,
      user: userId,
      paragraph: true,
      definite: false,
    }));
    setContent('');
  };

  //会话列表
  const [conversationList, setConversationList] = useState<any>([]);
  const onDateChoose = () => {
    //日期列表
    console.log((new Date()).toISOString().substring(0, 10));
    post('/cbc/history/list/by-date', {
      date: (new Date()).toISOString().substring(0, 10),
    }).then((res) => {
      console.log(res);
      if (res.code === 200) {
        setConversationList(res.data);
      }
    });
  };

  //登录用户信息
  const [userInfo, setUserInfo] = useState<any>({});
  useEffect(() => {
    //加载用户
    let userInfoStr = localStorage.getItem('userInfo');
    if (userInfoStr !== null) {
      let userInfo = JSON.parse(userInfoStr);
      setUserInfo(userInfo);
    }
    //当日咨询记录
    onDateChoose();
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      //结束当前会话
      stopConversation();
    };

    //监听tab关闭
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const clearAll  = () => {
    Dialog.show({
      title: '确认删除所有记录吗？',
      content: '确认后，所有记录将会消失，不可恢复。',
      closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: '取消',
          },
          {
            key: 'delete',
            text: '确认删除',
            bold: true,
            danger: true,
            onClick: ()=>{
              post("/cbc/history/deleteAll",{}).then((res)=>{
                if(res.code === 200){
                  setPopupVisible(false);
                }else{
                  message.error(res.msg)
                }
              })
            }
          },
        ],
      ],
    })
  }

  return (
    <div className={styles.conversationContainer}>

      <NavBar
        className={styles.navBar}
        style={{ height: 65 }}
        children={<img src={require('@/assets/img/title.png')} style={{ height: 35 }} alt="" />}
        backIcon={<img src={require('@/assets/img/menu.png')} style={{ height: 25 }} alt="" />}
        onBack={() => {
          setPopupVisible(true);
        }}
      />

      <div className={styles.wrapper}>
        <div ref={containerRef} className={styles.conversation}>
          <div key="doubao_profile" style={{ textAlign: 'center' }}>
            <img className={styles.doubaoIcon} key="doubao_profile" src={DoubaoProfileSVG}
                 alt="doubao_profile" />
          </div>

          {!isAIReady ? (
            <div className={styles.aiReadying}>
              <Spin size="small" className={styles['aiReading-spin']} />
              AI 准备中, 请稍侯
            </div>
          ) : (
            ''
          )}
          {msgHistory?.map(({ value, user, isInterrupted }, index) => {
            const isUserMsg = user === userId;
            const isRobotMsg = user === Config.BotName;
            if (!isUserMsg && !isRobotMsg) {
              return '';
            }
            // 欢迎词
            if (index === 0) {
              return (
                <div key="msg-welcome">
                  <div className={` ${isUserMsg ? styles.user : styles.robot}`}>
                    <div>{value}</div>
                  </div>
                  <div>{index === 0 && lines.map((line) => line)}</div>
                </div>
              );
            }
            // 对话内容
            return (
              <div className={`${styles.sentence} ${isUserMsg ? styles.user : styles.robot}`}
                   key={`msg-${index}`}>
                {/*对话内容*/}
                <span>{value}</span>
                {/*打断*/}
                {!isUserMsg && isInterrupted ? (
                  <>
                    ...
                    <Tag className={styles.interruptTag}>已打断</Tag>
                  </>
                ) : (
                  ''
                )}
                {/*对话中*/}
                {isAITalking && index === msgHistory.length - 1 ? <Loading /> : ''}
              </div>
            );
          })}

          {isAITalking ? (
            <Button type="text" onClick={handleInterrupt} className={styles.interrupt}
                    icon={<img src={StopRobotBtn} alt="StopRobotBtn" />}>
              手动停止，或者语音打断我
            </Button>
          ) : (
            ''
          )}
          {isUserTalking ? (
            <div key={`loading-isUserTalking-${isUserTalking}`}
                 className={`${styles.sentence} ${styles.user}`}>
              <Loading />
            </div>
          ) : (
            ''
          )}
        </div>

        {/*状态*/}
        <div className={styles.status}>
          {
            status === 'voice' && <>
              <Row>
                <Col span={3}>
                  <img className={styles.keyword} src={require('@/assets/img/keyword.png')} alt="" onClick={() => {
                    setStatus('keyword');
                  }} />

                </Col>
                <Col span={21}>
                  <img className={isUserTalking ? styles.userTalkingWave : styles.userStopTalkingWave}
                       src={WaveGIF} />
                  {/*<iframe className={styles.iframe} src="/siri/index.html"></iframe>*/}
                </Col>
              </Row>
            </>
          }
          {
            status === 'keyword' && <>
              <Row>
                <Col span={3}>
                  <img className={styles.keyword} src={require('@/assets/img/voice.png')} alt="" onClick={() => {
                    setStatus('voice');
                  }} />
                </Col>
                <Col span={21}>
                  <Search placeholder="发送消息..."
                          enterButton={<img className={styles.keyword} src={require('@/assets/img/sendout.png')}
                                            alt="" />}
                          value={content}
                          onChange={onChange}
                          onSearch={onSearch} />
                </Col>
              </Row>
            </>
          }

        </div>

      </div>
      <Popup
        visible={popupVisible}
        onMaskClick={() => {
          setPopupVisible(false);
        }}
        position="left"
        bodyStyle={{ width: '65vw' }}
      >
        <div className={styles.popupContent}>
          {
            userInfo && userInfo.status !== 'anonymous' && <>
              <List header="">
                <List.Item prefix={<AddOutline />} arrowIcon={false} onClick={startNewConversation}>
                  开启新对话
                </List.Item>
                <List.Item prefix={<CalendarOutline />} arrowIcon={false} onClick={() => {
                  //结束当前会话
                  stopConversation();
                  //跳转
                  navigate('/history');
                }}>
                  查看咨询历史
                </List.Item>
                <List.Item prefix={<DeleteOutline />} arrowIcon={false} onClick={() => {
                  clearAll();
                }} className={styles.clear}>
                  清除所有记录
                </List.Item>
              </List>
              {
                conversationList && conversationList.length > 0 && <List header="当日咨询记录">
                  {
                    conversationList && conversationList.map((item: any) => {
                      return <div key={item.id} className={styles.todayConversation}>
                        <List.Item arrowIcon={false} onClick={()=>{
                          //结束当前会话
                          stopConversation();
                          //跳转
                          navigate('/history/summary?conversationId=' + item.id);
                        }}>
                          {item.title}
                        </List.Item>
                      </div>;
                    })
                  }
                </List>
              }

            </>
          }

          {
            (userInfo === null || (userInfo && userInfo.status === 'anonymous')) && <>
              <div className={styles.tips}>
                <div className={styles.content}>欢迎使用账号登录</div>
                <div className={styles.content}>保存您的咨询记录</div>
                <div className={styles.btn}>
                  <Button ghost style={{ marginTop: 10 }} onClick={() => {
                    //结束当前会话
                    stopConversation();
                    navigate('/login');
                  }}>登录</Button>
                  <Button type="text" style={{ marginTop: 10 }} onClick={() => {
                    //结束当前会话
                    stopConversation();
                    navigate('/reg');
                  }}>注册</Button>
                </div>
              </div>
            </>
          }
        </div>
      </Popup>
    </div>
  );
}

export default Conversation;
